import { useDeviceType } from '@cian/ui-kit';
import { ComponentLayout } from '../types/layout';

export const useComponentLayout = (): ComponentLayout => {
  return useDeviceType() === 'desktop' ? ComponentLayout.Normal : ComponentLayout.Small;
};
